




















































































import Vue from 'vue'
import roleStoreService, { RoleInfo, isSystemRole } from './role-list.store'
import { finalize } from 'rxjs/operators'
const column = [
  {
    title: 'actions',
    dataIndex: 'edit',
    key: 'edit',
    width: 110,
    scopedSlots: { customRender: 'edit' }
  },
  {
    title: 'page_docdirectory_name',
    dataIndex: 'name',
    key: 'name',
    width: 100,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: 'page_extranet_Type',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' }
  }
]
export default Vue.extend({
  props: ['onRoleChange'],
  data() {
    return {
      list: [] as RoleInfo[],
      listX: [],
      modalVisible: false,
      saving: false,
      editRoleId: undefined as string | undefined,
      selectedRoleId: undefined as string | undefined,
      form: this.$form.createForm(this),
      selectedIds: [],
      selectedRowKeys: [], // 复选框勾选，多选
      selectedRows: [], // 复选框勾选的数据项(所有字段的集合)
      ifCreate: true
    }
  },
  computed: {
    columns() {
      const value = column.map((res) => {
        const item = {
          ...res,
          title: this.$t(res.title)
        }
        return item
      })
      return value
    }
  },
  methods: {
    customRow(record, index) {
      return {
        on: {
          click: () => {
            this.selectRole(record)
            console.log(record)
            let index = null
            this.selectedIds = [record.id]
            this.selectedRows = [record]
            let copy = JSON.parse(JSON.stringify(this.listX))
            for (var j = 0; j < copy.length; j++) {
              copy[j].choose = false
            }

            for (var i = 0; i < copy.length; i++) {
              if (copy[i].id == record.id) {
                index = i
                copy[i].choose = true
              }
            }
            this.listX = JSON.parse(JSON.stringify(copy))
            this.selectedRowKeys = [index]
          }
        }
      }
    },

    handleOk() {
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          values.id = this.editRoleId
          this.saveData(values as RoleInfo)
        }
      })
    },
    create() {
      this.editRoleId = undefined
      this.modalVisible = true
      this.ifCreate = true
    },
    saveData(role: RoleInfo) {
      this.saving = true
      roleStoreService
        .saveRole(role)
        .pipe(
          finalize(() => {
            this.saving = false
          })
        )
        .subscribe((res) => {
          if (res) {
            this.modalVisible = false
          }
        })
    },
    edit(role: RoleInfo) {
      this.ifCreate = false
      this.modalVisible = true
      this.editRoleId = role.id

      this.$nextTick(() => {
        // 必须延时处理，否则第二次打开时form表单值报错
        setTimeout(() => {
          this.form.setFieldsValue({ name: role.name })
        }, 0)
      })
    },
    remove(role: RoleInfo) {
      this.$confirm({
        content: `${this.$t('page_role_management_delete_or_not')}${role.name}${this.$t('role')}?`,
        onOk: () => {
          if (this.selectedRoleId === role.id) {
            this.selectedRoleId = undefined
          }
          roleStoreService.deleteRole(role.id as string).subscribe((res) => {
            this.$message.success(this.$t('page_role_management_delete_successful'))
          })
        },
        okText: this.$t('ok') as any,
        cancelText: this.$t('cancel') as any
      })
    },
    selectRole(role: RoleInfo) {
      this.selectedRoleId = role.id
      roleStoreService.selectRole(role)
      this.$emit('onRoleChange', { name: role.name, id: role.id })
    },
    roleDescription(roleName: string) {
      if (isSystemRole(roleName)) {
        return this.$t('page_role_management_system')
      }
      return this.$t('page_role_management_custom')
    },
    isSystemRole
  },
  watch: {
    list: {
      handler(val) {
        if (val && val.length) {
          let copy = JSON.parse(JSON.stringify(val))
          console.log(copy, '5556f5e6f')
          for (var j = 0; j < copy.length; j++) {
            copy[j].choose = false
          }
          copy[0].choose = true
          this.listX = JSON.parse(JSON.stringify(copy))
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    roleStoreService.roleList$.subscribe((res: RoleInfo[]) => {
      this.list = res
      if (this.list.length > 0 && this.selectedRoleId === undefined) {
        this.selectedRoleId = this.list[0].id
        this.$emit('onRoleChange', { name: this.list[0].name, id: this.list[0].id })
      }
      console.log(this.list, 'list')
    })

    roleStoreService.findAllRoleList()
  },
  destroyed() {
    roleStoreService.clearRoleList()
  }
})
